import { Actions } from './path-settings.actions'
import { fromJS } from 'immutable'
import * as PathSettingsTypes from './path-settings.types'

export const initialState = fromJS<any>({
  isLoading: false,
  validationErrors: {},
  data: {},
})

export function pathSettingsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case PathSettingsTypes.UPDATE_PATH_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case PathSettingsTypes.UPDATE_PATH_SETTINGS_SUCCESS: {
      return state.set('isLoading', false)
    }

    case PathSettingsTypes.UPDATE_PATH_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case PathSettingsTypes.FETCH_PATH_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case PathSettingsTypes.FETCH_PATH_SETTINGS_SUCCESS: {
      return state.set('isLoading', false).set('data', fromJS(action.payload))
    }

    case PathSettingsTypes.FETCH_PATH_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case PathSettingsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case PathSettingsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
